module.exports = "<label class=\"btn btn-default btn-sm\"> <div ng-transclude></div> <input type=file accept={{$ctrl.accept}} data-ng-required={{$ctrl.required}}> </label> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/load-file-button/load-file-button.html
// module id = 52
// module chunks = 0